<template>
  <div class="flex-1 mb-6 py-2">
    <a
      class="
        no-underline
        hover:no-underline
        font-bold
        text-2xl
        lg:text-4xl
        task-text
        px-6
        py-2
      "
      href="#"
      >Trackee
    </a>
    <p class="text-md py-6">
      Best tool for effective<br />
      collaboration, with a high performance results
    </p>


    
  </div>
</template>
<script>
export default {
  name: "LogoFooter",
};
</script>
<style scoped>
.task-text {
  border: 2px solid gray;
}
</style>